import { IApiRequestConfig } from '../api.types';
import { IUserCredentials, IUserCredentialsSSO } from '../../resource/user/user.types';
import { INewPassword } from '../../auth/auth.types';

export const loginApi = (
  payload: IUserCredentials | IUserCredentialsSSO,
): IApiRequestConfig<IUserCredentials, unknown> => ({
  apiRouteKey: 'login',
  uri: 'json',
  action: `signin`,
  method: 'post',
  data: payload,
  v2: true,
});

export const forgotPasswordApi = (email: string): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'forgotPassword',
  uri: 'json',
  action: `auth/forgot-password`,
  method: 'post',
  data: {
    email,
  },
  v2: true,
});

export const saveNewPasswordApi = (resetPassPayload: INewPassword): IApiRequestConfig<INewPassword, unknown> => ({
  apiRouteKey: 'saveNewPassword',
  uri: 'json',
  action: `auth/reset-password`,
  method: 'post',
  data: {
    ...resetPassPayload,
  },
  v2: true,
});
